const ZERO_PATH = "zero";

export const isZeroPage = (path?: string | string[]) => ZERO_PATH === path;
